import type { ColumnDef } from '@tanstack/vue-table'
import DataTableGoto from 'pejer/src/components/Table/core/DataTableGoto.vue'
import { getDefaultColumn } from 'pejer/src/helpers'
import { Customer } from 'pejer/src/tables/Customer'
import { getColumnByStringIndex } from 'pejer/src/utils'
import { h } from 'vue'

export const customersColumns: ColumnDef<Customer.ListItem>[] = [
  {
    accessorKey: 'customerId',
    meta: {
      hide_default: true,
    },
  },
  {
    accessorKey: 'name',
  },
  {
    accessorKey: 'email',
  },
  {
    accessorKey: 'mobile',
  },
  {
    accessorKey: 'numberOfPayments',
  },
  {
    accessorKey: 'amountSum',
  },
  {
    accessorKey: 'lastPayment',
  },
  {
    id: 'actions',
    meta: {
      placement: 'end',
    },
    size: 40,
    cell: ({ row }) => {
      const customer = row.original

      const args = {
        name: 'Customer',
        id: getColumnByStringIndex(customer, getDefaultColumn('customers').id),
        pathName: 'customer',
      }

      return h('div', { style: { display: 'flex', justifyContent: 'end' } }, h(DataTableGoto, args))
    },
  },
]
